import React, { Component } from 'react';
import Slider from 'react-slick';
import _forEach from 'lodash/forEach';
import logger from './utils/logging';
import { joinClasses } from 'components/utils/react_helper';
import CarouselArrow from 'components/carousel_arrow';

export default class HeaderSlider extends Component {
  constructor(props) {
    super(props);

    const initialIndex = this._getInitial(this.props.slides);
    this.state = {
      slides: this.props.slides,
      initialIndex: initialIndex,
      index: initialIndex,
    };
    logger.info('[HeaderSlider] Initializing');
    logger.info('[HeaderSlider] ' + JSON.stringify(this.props.slides));

    this._loadSlide(initialIndex);
    this._loadNext(initialIndex);
    this._loadPrev(this.props.slides.length); // load last slide in case users first click is previous on slider
  }

  componentDidMount() {
    if (this.props.enableArrowKeys) {
      document.addEventListener('keydown', this.onKeyPress, false);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyPress, false);
  }

  onKeyPress = (key) => {
    if (key.code == 'ArrowLeft') {
      this._onPrev();
    } else if (key.code == 'ArrowRight') {
      this._onNext();
    }
  };

  _loadNext = (index) => {
    const length = this.numberOfSlides;
    if (length > 1) {
      this._loadSlide((index + 1) % length); // next
    }
    if (length > 2) {
      this._loadSlide((index + 2) % length); // next + 1
    }
  };

  _loadPrev = (index) => {
    const length = this.numberOfSlides;
    if (length > 1) {
      this._loadSlide(Math.abs((index - 1) % length)); // prev
    }
    if (length > 2) {
      this._loadSlide(Math.abs((index - 2) % length)); // prev - 1
    }
  };

  _loadSlide = (index) => {
    const img = new Image();
    img.addEventListener(
      'load',
      (event) => {
        const slides = this.state.slides.slice(0);
        slides[index].loaded = true;
        this.setState({ slides });
      },
      false
    );
    img.src = this.state.slides[index].img;
  };

  _getSlides = () => {
    return this.props.slides.map((slide, index) => {
      // if we are looking at the current slide, and it's not loaded,
      // load that slide now. this is a fallback to avoid showing a
      // slide with no image - ideally the images should already be loaded
      // via _loadNext && _loadPrev
      if (this.state.index == index && !slide.loaded) {
        this._loadSlide(index);
      }

      let url = '';
      if (slide.loaded) {
        url = `url(${slide.img})`;
      }

      var style = {
        backgroundImage: `${url}`,
        backgroundPosition: slide.yPos || '50%',
        height: '100%',
        backgroundSize: 'cover',
      };

      const background = /Edge/.test(window.navigator.userAgent)
        ? 'rgba(38, 45, 78, 0.6)'
        : 'linear-gradient(to bottom, rgb(38, 45, 78, 0), rgba(38, 45, 78, 0.6))';
      const gradient = this.props.hideGradient ? '' : background;

      var innerStyle = {
        height: '100%',
        width: '100%',
        background: `${gradient}`,
      };

      return (
        <div key={slide.img} className="slide slide--header" onClick={this.handleOnImageClick}>
          <div style={style}>
            <div style={innerStyle}></div>
          </div>
        </div>
      );
    });
  };

  handleOnImageClick = () => {
    window.headerImageClicked();
  };

  _getInitial = (slides) => {
    if (typeof this.props.initial === 'number') {
      return this.props.initial;
    }

    var max = slides.length - 1;
    var min = 0;
    var initial = Math.floor(Math.random() * (max - min + 1)) + min;

    return initial;
  };

  _afterChange = (i) => {
    this.setState({ index: i });
  };

  _beforeChange = (previous, next) => {
    if (previous < next) {
      // clicking to next slide
      this._loadNext(next);
    } else {
      // user has clicked previous slide
      this._loadPrev(next);
    }
  };

  _onPrev = () => {
    this.slider.slickPrev();
  };

  _onNext = () => {
    this.slider.slickNext();
  };

  render = () => {
    const autoplay = this.props.autoplay === undefined || this.props.autoplay;
    const settings = {
      dots: false,
      arrows: false,
      infinite: true,
      speed: 500,
      adaptiveHeight: false,
      fade: true,
      autoplay: autoplay,
      autoplaySpeed: 5000,
      initialSlide: this.state.index,
      afterChange: this._afterChange,
      beforeChange: this._beforeChange,
    };
    if (this.state.slides[this.state.initialIndex].loaded) {
      return (
        <div className="site-header-slides">
          <Slider ref={(slider) => (this.slider = slider)} {...settings}>
            {this._getSlides()}
          </Slider>
          <div className="site-header-slides-hero-nav">
            <CarouselArrow arrow={'previous'} slider={this.slider} slides={this.state.slides} />
            {this.renderCaption()}
            <CarouselArrow arrow={'next'} slider={this.slider} slides={this.state.slides} />
          </div>
        </div>
      );
    } else {
      return <div className="site-header-slides site-header-slides--loading"></div>;
    }
  };

  renderPrevButton = () => {
    if (this.state.slides.length < 2) {
      return null;
    }
    return (
      <div className="site-header-slides-hero-nav-previous" onClick={this._onPrev}>
        &lsaquo;
      </div>
    );
  };

  renderNextButton = () => {
    if (this.state.slides.length < 2) {
      return null;
    }
    return (
      <div className="site-header-slides-hero-nav-next" onClick={this._onNext}>
        &rsaquo;
      </div>
    );
  };

  renderCaption = () => {
    const description = this.state.slides[this.state.index].description;

    if (!description) {
      return null;
    }

    return <div className={this.captionClasses}>{description}</div>;
  };

  get captionClasses() {
    return joinClasses([
      'site-header-slides-hero-nav-title',
      this.props.disableCaptions && 'site-header-slides-hero-nav-title--hidden',
    ]);
  }

  get numberOfSlides() {
    return this.state.slides.length;
  }
}
